export function formatCurrency(
  value,
  locale = "es-MX",
  currency = "MXN",
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
) {
  // Asegúrate de pasar siempre un Number
  const number = typeof value === "number" ? value : parseFloat(value) || 0;

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(number);
}
